import { type Ya, type YaContextCb } from '@/app/types/yandex';

import { makeResolveInstance } from '@/shared/factories/helpers/make-resolve-instance';

export interface YaInstance {
  yandex: Ya;
  cb: YaContextCb;
}

export const resolveYandexAdsInstance = makeResolveInstance<YaInstance>(() => {
  if (window.Ya && window.yaContextCb) {
    return {
      yandex: window.Ya,
      cb: window.yaContextCb,
    };
  }

  return undefined;
});
